const HeaderUpdateHeight = (header) => {
    // Update --header-height CSS variable;
    const updateHeaderHeight = () => {
        const headerSearchHeight = header.querySelector('.mid-navbar-wrapper')?.offsetHeight;
        const headerAnchorsHeight = header.querySelector('.anchor-menu')?.offsetHeight;
        document.body.style.setProperty(
            '--header-search-height',
            `${headerSearchHeight || 0}px`,
        );
        document.body.style.setProperty(
            '--header-anchors-height',
            `${headerAnchorsHeight || 0}px`,
        );
        setTimeout(() => {
            const headerHeight = header.offsetHeight + (headerAnchorsHeight || 0);
            document.body.style.setProperty(
                '--header-height',
                `${headerHeight}px`,
            );
        })
    }
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    document.addEventListener('forceResizeEvent', updateHeaderHeight);
}

export default HeaderUpdateHeight;